/* Графики (PRO-6): спарклайн в таблице и линейный график в карточке — как в прототипе (ui.js). */
import { useId } from 'react';
import { dm, fmtNum } from '../lib/format';

export function Sparkline({ vals, w = 64, h = 20, color = 'var(--acc)' }: { vals: number[]; w?: number; h?: number; color?: string }) {
  if (!vals || vals.length < 2) return null;
  const min = Math.min(...vals),
    max = Math.max(...vals),
    sp = max - min || 1;
  const pts = vals.map((v, i) => [(i / (vals.length - 1)) * w, h - 2 - ((v - min) / sp) * (h - 4)]);
  const last = pts[pts.length - 1];
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} fill="none">
      <polyline points={pts.map((p) => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' ')} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r="2" fill={color} />
    </svg>
  );
}

export function LineChart({ series, unit = 'кг' }: { series: [string, number][]; unit?: string }) {
  const gid = 'lg' + useId().replace(/:/g, '');
  const W = 640,
    H = 190,
    PL = 44,
    PR = 16,
    PT = 18,
    PB = 26;
  if (!series || series.length < 2) return <div style={{ padding: 26, textAlign: 'center', color: 'var(--tx3)', fontSize: 13 }}>Недостаточно данных для графика</div>;
  const vals = series.map((s) => s[1]);
  const min = Math.min(...vals),
    max = Math.max(...vals);
  const lo = min - (max - min || 10) * 0.35,
    hi = max + (max - min || 10) * 0.2;
  const x = (i: number) => PL + (i / (series.length - 1)) * (W - PL - PR);
  const y = (v: number) => PT + (1 - (v - lo) / (hi - lo)) * (H - PT - PB);
  const ticks = [lo + (hi - lo) * 0.15, (lo + hi) / 2, hi - (hi - lo) * 0.08].map((v) => Math.round(v / 2.5) * 2.5);
  const pts = series.map((s, i) => [x(i), y(s[1])]);
  const path = pts.map((p, i) => (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
  const area = path + ` L${pts[pts.length - 1][0].toFixed(1)} ${H - PB} L${pts[0][0].toFixed(1)} ${H - PB} Z`;
  const lastV = series[series.length - 1][1];
  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="xMidYMid meet">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="var(--acc)" stopOpacity=".16" />
          <stop offset="1" stopColor="var(--acc)" stopOpacity="0" />
        </linearGradient>
      </defs>
      {ticks.map((t, i) => (
        <g key={i}>
          <line x1={PL} y1={y(t).toFixed(1)} x2={W - PR} y2={y(t).toFixed(1)} stroke="var(--line)" />
          <text className="yl" x={PL - 8} y={(y(t) + 3).toFixed(1)} textAnchor="end">
            {fmtNum(t)}
          </text>
        </g>
      ))}
      <path d={area} fill={`url(#${gid})`} />
      <path d={path} fill="none" stroke="var(--acc)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      {pts.map((p, i) => (
        <circle key={i} cx={p[0].toFixed(1)} cy={p[1].toFixed(1)} r={i === pts.length - 1 ? 4 : 3} fill={i === pts.length - 1 ? 'var(--acc)' : 'var(--bg)'} stroke="var(--acc)" strokeWidth="1.6" />
      ))}
      {series.map((s, i) => (
        <text key={i} className="yl" x={x(i).toFixed(1)} y={H - 8} textAnchor="middle">
          {dm(s[0])}
        </text>
      ))}
      <text className="yl" x={x(series.length - 1).toFixed(1)} y={(y(lastV) - 11).toFixed(1)} textAnchor="middle" fill="var(--acc)" style={{ fontSize: 13, fontWeight: 700 }}>
        {fmtNum(lastV)} {unit}
      </text>
    </svg>
  );
}
